import { createContext, useCallback, useMemo, useState } from "react";
import DatasetWorkspaceSidebar from "./DatasetWorkspaceSidebar";
import "../../styles/DatasetPage.css";

export const DatasetWorkspaceGroupContext = createContext(null);

function DatasetWorkspaceShell({
  children,
  mainClassName = "",
  storageLabel,
  storageValue,
  showGroups = true,
}) {
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groupNames, setGroupNames] = useState([]);

  const onGroupSelect = useCallback((group) => {
    setSelectedGroup(group);
  }, []);

  const onGroupsChange = useCallback((names) => {
    setGroupNames(names);
  }, []);

  const contextValue = useMemo(
    () => ({
      selectedGroup,
      onGroupSelect,
      onGroupsChange,
    }),
    [selectedGroup, onGroupSelect, onGroupsChange]
  );

  const mainClass = mainClassName
    ? `dataset-page ${mainClassName}`
    : "dataset-page";

  return (
    <DatasetWorkspaceGroupContext.Provider value={contextValue}>
      <div className="dataset-shell">
        <DatasetWorkspaceSidebar
          storageLabel={storageLabel}
          storageValue={storageValue}
          groupNames={groupNames}
          selectedGroup={selectedGroup}
          onGroupSelect={onGroupSelect}
          showGroups={showGroups}
        />
        <main className={mainClass}>{children}</main>
      </div>
    </DatasetWorkspaceGroupContext.Provider>
  );
}

export default DatasetWorkspaceShell;
